// 3-digit ZIP prefix centroids, projected into the same viewBox as
// usMapOutline.ts (identical d3-geoAlbersUsa projection, so dots align with
// the map). Averaged from the public-domain 2013 US ZIP lat/long dataset.
// Territories outside the AlbersUsa US frame (e.g. PR) are omitted.

export interface Zip3Centroid {
  /** First 3 digits of the ZIP code. */
  zip3: string;
  x: number;
  y: number;
}

export const ZIP3_CENTROIDS: ReadonlyArray<Zip3Centroid> = [
  { x: 891.6, y: 173.1, zip3: '010' },
  { x: 892.8, y: 176.4, zip3: '011' },
  { x: 881.2, y: 174.1, zip3: '012' },
  { x: 889.8, y: 166.3, zip3: '013' },
  { x: 901.9, y: 163.4, zip3: '014' },
  { x: 903.3, y: 171.2, zip3: '015' },
  { x: 903.1, y: 170.2, zip3: '016' },
  { x: 908.3, y: 167, zip3: '017' },
  { x: 910.4, y: 159.9, zip3: '018' },
  { x: 915.2, y: 159.3, zip3: '019' },
  { x: 914.1, y: 169.9, zip3: '020' },
  { x: 914.3, y: 165.7, zip3: '021' },
  { x: 914.1, y: 165.4, zip3: '022' },
  { x: 918.4, y: 171.6, zip3: '023' },
  { x: 911.9, y: 166, zip3: '024' },
  { x: 926.5, y: 179.1, zip3: '025' },
  { x: 931.3, y: 174.5, zip3: '026' },
  { x: 917.4, y: 177.9, zip3: '027' },
  { x: 910.8, y: 181.5, zip3: '028' },
  { x: 911.5, y: 178, zip3: '029' },
  { x: 904.5, y: 156.1, zip3: '030' },
  { x: 904.6, y: 153.6, zip3: '031' },
  { x: 898.8, y: 143.3, zip3: '032' },
  { x: 901.8, y: 148.5, zip3: '033' },
  { x: 893.7, y: 158.1, zip3: '034' },
  { x: 896.4, y: 122.3, zip3: '035' },
  { x: 890.4, y: 153.2, zip3: '036' },
  { x: 890.8, y: 141.5, zip3: '037' },
  { x: 908.3, y: 143.4, zip3: '038' },
  { x: 914.9, y: 146.2, zip3: '039' },
  { x: 914.3, y: 134.1, zip3: '040' },
  { x: 919.1, y: 134.6, zip3: '041' },
  { x: 913, y: 121.4, zip3: '042' },
  { x: 922.1, y: 119.7, zip3: '043' },
  { x: 932.6, y: 97.4, zip3: '044' },
  { x: 927.5, y: 126.1, zip3: '045' },
  { x: 946.7, y: 107, zip3: '046' },
  { x: 929.6, y: 63.9, zip3: '047' },
  { x: 933.4, y: 120.9, zip3: '048' },
  { x: 921.1, y: 109.2, zip3: '049' },
  { x: 885.9, y: 139.4, zip3: '050' },
  { x: 885.4, y: 152.6, zip3: '051' },
  { x: 879.3, y: 159.1, zip3: '052' },
  { x: 884.8, y: 159.9, zip3: '053' },
  { x: 872.3, y: 125.9, zip3: '054' },
  { x: 880.9, y: 129.7, zip3: '056' },
  { x: 877.2, y: 145.5, zip3: '057' },
  { x: 885.1, y: 120.9, zip3: '058' },
  { x: 891.9, y: 117.4, zip3: '059' },
  { x: 889.9, y: 182.6, zip3: '060' },
  { x: 892.4, y: 184.3, zip3: '061' },
  { x: 901.2, y: 181, zip3: '062' },
  { x: 903.9, y: 187, zip3: '063' },
  { x: 893.3, y: 191.3, zip3: '064' },
  { x: 890.9, y: 194, zip3: '065' },
  { x: 887.6, y: 197.8, zip3: '066' },
  { x: 885.3, y: 188.6, zip3: '067' },
  { x: 883.7, y: 199.1, zip3: '068' },
  { x: 882.8, y: 201.6, zip3: '069' },
  { x: 873.6, y: 211.1, zip3: '070' },
  { x: 874.4, y: 211.2, zip3: '071' },
  { x: 874.2, y: 212.9, zip3: '072' },
  { x: 876.5, y: 211.2, zip3: '073' },
  { x: 871.1, y: 205.3, zip3: '074' },
  { x: 873.8, y: 207.4, zip3: '075' },
  { x: 876.1, y: 206.7, zip3: '076' },
  { x: 877.9, y: 219.9, zip3: '077' },
  { x: 864.6, y: 209.3, zip3: '078' },
  { x: 869.2, y: 212.5, zip3: '079' },
  { x: 866.2, y: 233.6, zip3: '080' },
  { x: 864.1, y: 231.6, zip3: '081' },
  { x: 873.9, y: 244, zip3: '082' },
  { x: 867.4, y: 242.1, zip3: '083' },
  { x: 876.3, y: 242, zip3: '084' },
  { x: 869.5, y: 223.1, zip3: '085' },
  { x: 868.9, y: 224.6, zip3: '086' },
  { x: 878.6, y: 227.1, zip3: '087' },
  { x: 868.4, y: 217.1, zip3: '088' },
  { x: 871.5, y: 217.9, zip3: '089' },
  { x: 877.6, y: 209.9, zip3: '100' },
  { x: 877.6, y: 210.1, zip3: '101' },
  { x: 877.3, y: 211.3, zip3: '102' },
  { x: 875.7, y: 214.4, zip3: '103' },
  { x: 878.7, y: 207.9, zip3: '104' },
  { x: 878.6, y: 200.2, zip3: '105' },
  { x: 879.4, y: 203.5, zip3: '106' },
  { x: 878.6, y: 205.7, zip3: '107' },
  { x: 879.7, y: 206.1, zip3: '108' },
  { x: 872.1, y: 200.2, zip3: '109' },
  { x: 881.8, y: 209.3, zip3: '110' },
  { x: 878.4, y: 210, zip3: '111' },
  { x: 878.4, y: 212.3, zip3: '112' },
  { x: 879.9, y: 209.7, zip3: '113' },
  { x: 880.7, y: 210.9, zip3: '114' },
  { x: 883.2, y: 209.9, zip3: '115' },
  { x: 880.8, y: 213.3, zip3: '116' },
  { x: 889, y: 206.4, zip3: '117' },
  { x: 885.3, y: 208.1, zip3: '118' },
  { x: 899, y: 201.1, zip3: '119' },
  { x: 868.5, y: 169.4, zip3: '120' },
  { x: 868.6, y: 169.5, zip3: '121' },
  { x: 871, y: 169.2, zip3: '122' },
  { x: 868, y: 166.9, zip3: '123' },
  { x: 867.4, y: 183.1, zip3: '124' },
  { x: 874.6, y: 188.2, zip3: '125' },
  { x: 874.3, y: 190.2, zip3: '126' },
  { x: 860.8, y: 193.3, zip3: '127' },
  { x: 867.6, y: 151.7, zip3: '128' },
  { x: 859.7, y: 130.3, zip3: '129' },
  { x: 832.9, y: 170.9, zip3: '130' },
  { x: 831.7, y: 169.5, zip3: '131' },
  { x: 833.1, y: 169.3, zip3: '132' },
  { x: 846.8, y: 163.9, zip3: '133' },
  { x: 846.6, y: 164.9, zip3: '134' },
  { x: 847.5, y: 164.9, zip3: '135' },
  { x: 836.9, y: 141.2, zip3: '136' },
  { x: 847.4, y: 184, zip3: '137' },
  { x: 845.5, y: 182.2, zip3: '138' },
  { x: 841.2, y: 188.1, zip3: '139' },
  { x: 796, y: 182.3, zip3: '140' },
  { x: 795.2, y: 182, zip3: '141' },
  { x: 792.7, y: 180.3, zip3: '142' },
  { x: 789, y: 176.9, zip3: '143' },
  { x: 810.8, y: 176.1, zip3: '144' },
  { x: 813.2, y: 176.1, zip3: '145' },
  { x: 810.2, y: 171.4, zip3: '146' },
  { x: 794.9, y: 195.6, zip3: '147' },
  { x: 821.2, y: 188.3, zip3: '148' },
  { x: 827.1, y: 191.7, zip3: '149' },
  { x: 782.5, y: 236.1, zip3: '150' },
  { x: 784.9, y: 236.5, zip3: '151' },
  { x: 783.9, y: 236.1, zip3: '152' },
  { x: 782.4, y: 245.5, zip3: '153' },
  { x: 789.2, y: 245.8, zip3: '154' },
  { x: 803.2, y: 243, zip3: '155' },
  { x: 791.5, y: 237.7, zip3: '156' },
  { x: 798.1, y: 227.4, zip3: '157' },
  { x: 801.1, y: 215.4, zip3: '158' },
  { x: 802.3, y: 234.7, zip3: '159' },
  { x: 783.6, y: 225.6, zip3: '160' },
  { x: 775.4, y: 221.7, zip3: '161' },
  { x: 791.4, y: 222.9, zip3: '162' },
  { x: 786.3, y: 211.3, zip3: '163' },
  { x: 778, y: 205.4, zip3: '164' },
  { x: 776.6, y: 200.7, zip3: '165' },
  { x: 809.9, y: 231.1, zip3: '166' },
  { x: 802, y: 202.9, zip3: '167' },
  { x: 813.5, y: 219.8, zip3: '168' },
  { x: 820.8, y: 198.8, zip3: '169' },
  { x: 830.9, y: 228.3, zip3: '170' },
  { x: 834.4, y: 230.3, zip3: '171' },
  { x: 821, y: 239.1, zip3: '172' },
  { x: 836.2, y: 238.3, zip3: '173' },
  { x: 837.9, y: 236.8, zip3: '174' },
  { x: 845.1, y: 233.3, zip3: '175' },
  { x: 844.2, y: 233.2, zip3: '176' },
  { x: 825.8, y: 209.6, zip3: '177' },
  { x: 832.6, y: 217.1, zip3: '178' },
  { x: 841.6, y: 219.3, zip3: '179' },
  { x: 854.8, y: 218.1, zip3: '180' },
  { x: 854.2, y: 219.1, zip3: '181' },
  { x: 845.9, y: 213.9, zip3: '182' },
  { x: 856.3, y: 207.8, zip3: '183' },
  { x: 851.6, y: 198.2, zip3: '184' },
  { x: 848, y: 202.3, zip3: '185' },
  { x: 842.2, y: 205.6, zip3: '186' },
  { x: 845.3, y: 206.7, zip3: '187' },
  { x: 839.2, y: 195.1, zip3: '188' },
  { x: 860.9, y: 223.1, zip3: '189' },
  { x: 861.7, y: 230.3, zip3: '190' },
  { x: 862.8, y: 230.5, zip3: '191' },
  { x: 853.9, y: 233.7, zip3: '193' },
  { x: 857.5, y: 227.4, zip3: '194' },
  { x: 849.1, y: 224.3, zip3: '195' },
  { x: 848.5, y: 226, zip3: '196' },
  { x: 856.4, y: 239.6, zip3: '197' },
  { x: 857.2, y: 236.9, zip3: '198' },
  { x: 863.6, y: 256, zip3: '199' },
  { x: 837.5, y: 259.9, zip3: '200' },
  { x: 828.1, y: 261.6, zip3: '201' },
  { x: 837.5, y: 260.4, zip3: '202' },
  { x: 837.8, y: 260, zip3: '203' },
  { x: 837.2, y: 260.3, zip3: '204' },
  { x: 837.6, y: 260.4, zip3: '205' },
  { x: 844.7, y: 269.9, zip3: '206' },
  { x: 841.1, y: 259, zip3: '207' },
  { x: 834.3, y: 255.9, zip3: '208' },
  { x: 837.2, y: 257.1, zip3: '209' },
  { x: 843.2, y: 248.9, zip3: '210' },
  { x: 841.5, y: 247.8, zip3: '211' },
  { x: 842.6, y: 249.9, zip3: '212' },
  { x: 845.6, y: 256.4, zip3: '214' },
  { x: 802.4, y: 251.8, zip3: '215' },
  { x: 853.6, y: 257.9, zip3: '216' },
  { x: 827.7, y: 249.2, zip3: '217' },
  { x: 863.2, y: 268.7, zip3: '218' },
  { x: 851.9, y: 242.5, zip3: '219' },
  { x: 834.2, y: 262.8, zip3: '220' },
  { x: 834, y: 263.5, zip3: '221' },
  { x: 836.5, y: 260.9, zip3: '222' },
  { x: 836.9, y: 262.7, zip3: '223' },
  { x: 841.9, y: 277.5, zip3: '224' },
  { x: 840.7, y: 278.6, zip3: '225' },
  { x: 817.6, y: 261.5, zip3: '226' },
  { x: 822.6, y: 272.5, zip3: '227' },
  { x: 809.6, y: 272.6, zip3: '228' },
  { x: 815.5, y: 284, zip3: '229' },
  { x: 841.1, y: 288.1, zip3: '230' },
  { x: 842.2, y: 288.5, zip3: '231' },
  { x: 835.8, y: 290.4, zip3: '232' },
  { x: 862.1, y: 288.3, zip3: '233' },
  { x: 861.6, y: 290.6, zip3: '234' },
  { x: 858.7, y: 300.3, zip3: '235' },
  { x: 855, y: 296.4, zip3: '236' },
  { x: 858, y: 301.7, zip3: '237' },
  { x: 839.5, y: 302.5, zip3: '238' },
  { x: 822.6, y: 304.7, zip3: '239' },
  { x: 794.1, y: 307.2, zip3: '240' },
  { x: 793.4, y: 308, zip3: '241' },
  { x: 755, y: 319.3, zip3: '242' },
  { x: 777.9, y: 316.3, zip3: '243' },
  { x: 802.5, y: 285, zip3: '244' },
  { x: 810.1, y: 304.2, zip3: '245' },
  { x: 765.3, y: 310.1, zip3: '246' },
  { x: 773.9, y: 304.4, zip3: '247' },
  { x: 767, y: 304.1, zip3: '248' },
  { x: 786.4, y: 292.1, zip3: '249' },
  { x: 767.3, y: 288.3, zip3: '250' },
  { x: 766.6, y: 287.6, zip3: '251' },
  { x: 764.7, y: 279.4, zip3: '252' },
  { x: 764.3, y: 285, zip3: '253' },
  { x: 818.6, y: 252.6, zip3: '254' },
  { x: 755.7, y: 287.9, zip3: '255' },
  { x: 759.8, y: 298.8, zip3: '256' },
  { x: 751.6, y: 286.3, zip3: '257' },
  { x: 773, y: 296.4, zip3: '258' },
  { x: 775.6, y: 295.8, zip3: '259' },
  { x: 774.6, y: 243.7, zip3: '260' },
  { x: 767.6, y: 266, zip3: '261' },
  { x: 788.8, y: 272.5, zip3: '262' },
  { x: 779.4, y: 264.3, zip3: '263' },
  { x: 781.6, y: 262.9, zip3: '264' },
  { x: 784.6, y: 255.1, zip3: '265' },
  { x: 777.8, y: 280.2, zip3: '266' },
  { x: 804.1, y: 256.8, zip3: '267' },
  { x: 805.3, y: 264.8, zip3: '268' },
  { x: 792.1, y: 327, zip3: '270' },
  { x: 794.9, y: 329.9, zip3: '271' },
  { x: 805.5, y: 332.2, zip3: '272' },
  { x: 807, y: 331.4, zip3: '273' },
  { x: 802.4, y: 328.8, zip3: '274' },
  { x: 824.1, y: 329.4, zip3: '275' },
  { x: 823.3, y: 330.7, zip3: '276' },
  { x: 818.6, y: 328.1, zip3: '277' },
  { x: 844, y: 325, zip3: '278' },
  { x: 863.9, y: 316.9, zip3: '279' },
  { x: 784.7, y: 347.5, zip3: '280' },
  { x: 789.6, y: 348.4, zip3: '281' },
  { x: 788.4, y: 350.4, zip3: '282' },
  { x: 821.1, y: 349.7, zip3: '283' },
  { x: 836.4, y: 361.6, zip3: '284' },
  { x: 853.4, y: 343, zip3: '285' },
  { x: 776.3, y: 333, zip3: '286' },
  { x: 754.9, y: 350.3, zip3: '287' },
  { x: 757.6, y: 346.5, zip3: '288' },
  { x: 735.6, y: 360.5, zip3: '289' },
  { x: 792.9, y: 377, zip3: '290' },
  { x: 791.9, y: 378.9, zip3: '291' },
  { x: 789.4, y: 376, zip3: '292' },
  { x: 770.9, y: 361, zip3: '293' },
  { x: 808.4, y: 396.3, zip3: '294' },
  { x: 816.7, y: 370.5, zip3: '295' },
  { x: 759.9, y: 366.3, zip3: '296' },
  { x: 787.7, y: 358, zip3: '297' },
  { x: 777.1, y: 388.5, zip3: '298' },
  { x: 795.6, y: 407.7, zip3: '299' },
  { x: 734.7, y: 387.4, zip3: '300' },
  { x: 722.4, y: 385.8, zip3: '301' },
  { x: 730.8, y: 399.8, zip3: '302' },
  { x: 730.9, y: 389.3, zip3: '303' },
  { x: 774.7, y: 413.4, zip3: '304' },
  { x: 740.6, y: 372.1, zip3: '305' },
  { x: 750.6, y: 385.1, zip3: '306' },
  { x: 715.6, y: 370, zip3: '307' },
  { x: 768, y: 394.4, zip3: '308' },
  { x: 772.9, y: 391.1, zip3: '309' },
  { x: 750.6, y: 413.4, zip3: '310' },
  { x: 746.3, y: 408.3, zip3: '312' },
  { x: 789.3, y: 421.7, zip3: '313' },
  { x: 794, y: 418.7, zip3: '314' },
  { x: 778.3, y: 436.5, zip3: '315' },
  { x: 759.8, y: 446.6, zip3: '316' },
  { x: 746.6, y: 437.8, zip3: '317' },
  { x: 728.3, y: 417.4, zip3: '318' },
  { x: 724.3, y: 418.9, zip3: '319' },
  { x: 780.6, y: 461.7, zip3: '320' },
  { x: 797.6, y: 477.8, zip3: '321' },
  { x: 790.6, y: 457.3, zip3: '322' },
  { x: 742.3, y: 463.7, zip3: '323' },
  { x: 718.5, y: 462.1, zip3: '324' },
  { x: 691.9, y: 464, zip3: '325' },
  { x: 777, y: 474.6, zip3: '326' },
  { x: 801.1, y: 488.7, zip3: '327' },
  { x: 801.8, y: 494.6, zip3: '328' },
  { x: 817, y: 502.3, zip3: '329' },
  { x: 828.7, y: 549.6, zip3: '330' },
  { x: 831.2, y: 549, zip3: '331' },
  { x: 830.8, y: 541.3, zip3: '333' },
  { x: 829.7, y: 530.7, zip3: '334' },
  { x: 785.7, y: 505.2, zip3: '335' },
  { x: 782, y: 508.5, zip3: '336' },
  { x: 777.6, y: 512.1, zip3: '337' },
  { x: 797.4, y: 508.8, zip3: '338' },
  { x: 797.1, y: 534.3, zip3: '339' },
  { x: 803.9, y: 545.6, zip3: '341' },
  { x: 785.4, y: 523, zip3: '342' },
  { x: 781.8, y: 486.5, zip3: '344' },
  { x: 778.7, y: 502.3, zip3: '346' },
  { x: 797.2, y: 495.9, zip3: '347' },
  { x: 823.3, y: 516.8, zip3: '349' },
  { x: 690.4, y: 398.8, zip3: '350' },
  { x: 691.9, y: 400.1, zip3: '351' },
  { x: 689, y: 400.3, zip3: '352' },
  { x: 672.2, y: 410.4, zip3: '354' },
  { x: 672.8, y: 391.6, zip3: '355' },
  { x: 677.8, y: 375.7, zip3: '356' },
  { x: 694.5, y: 372.9, zip3: '357' },
  { x: 689.7, y: 374.1, zip3: '358' },
  { x: 702.4, y: 381.8, zip3: '359' },
  { x: 703.4, y: 428.4, zip3: '360' },
  { x: 700.7, y: 424, zip3: '361' },
  { x: 708.3, y: 397.6, zip3: '362' },
  { x: 716.5, y: 445.3, zip3: '363' },
  { x: 688.8, y: 445.6, zip3: '364' },
  { x: 673.1, y: 458.5, zip3: '365' },
  { x: 670.5, y: 463, zip3: '366' },
  { x: 681.4, y: 426.9, zip3: '367' },
  { x: 716.8, y: 417.4, zip3: '368' },
  { x: 665.7, y: 432, zip3: '369' },
  { x: 682.5, y: 344, zip3: '370' },
  { x: 684.3, y: 344.9, zip3: '371' },
  { x: 683.6, y: 343.4, zip3: '372' },
  { x: 710.4, y: 359.9, zip3: '373' },
  { x: 712, y: 364.4, zip3: '374' },
  { x: 758.8, y: 329.4, zip3: '376' },
  { x: 732.8, y: 337.9, zip3: '377' },
  { x: 734.6, y: 338.7, zip3: '378' },
  { x: 732, y: 341.9, zip3: '379' },
  { x: 639.2, y: 360.6, zip3: '380' },
  { x: 631.1, y: 369.9, zip3: '381' },
  { x: 650.5, y: 343.4, zip3: '382' },
  { x: 655.4, y: 358.1, zip3: '383' },
  { x: 676.5, y: 362.6, zip3: '384' },
  { x: 707, y: 339.8, zip3: '385' },
  { x: 634.2, y: 381.3, zip3: '386' },
  { x: 617.8, y: 404.5, zip3: '387' },
  { x: 655.5, y: 385.2, zip3: '388' },
  { x: 632.5, y: 398.9, zip3: '389' },
  { x: 630.7, y: 427, zip3: '390' },
  { x: 630.3, y: 429, zip3: '391' },
  { x: 630.5, y: 430.9, zip3: '392' },
  { x: 654.9, y: 427.3, zip3: '393' },
  { x: 648, y: 450.5, zip3: '394' },
  { x: 654.7, y: 469.2, zip3: '395' },
  { x: 624.9, y: 452, zip3: '396' },
  { x: 652, y: 402.9, zip3: '397' },
  { x: 732.6, y: 442.5, zip3: '398' },
  { x: 703.9, y: 298.3, zip3: '400' },
  { x: 690.4, y: 305.2, zip3: '401' },
  { x: 697.5, y: 297, zip3: '402' },
  { x: 723, y: 297.7, zip3: '403' },
  { x: 720.5, y: 310, zip3: '404' },
  { x: 717.9, y: 298.6, zip3: '405' },
  { x: 711.2, y: 295.5, zip3: '406' },
  { x: 727.6, y: 320.9, zip3: '407' },
  { x: 741.6, y: 320.5, zip3: '408' },
  { x: 734.3, y: 321, zip3: '409' },
  { x: 716.9, y: 282, zip3: '410' },
  { x: 742.2, y: 287.7, zip3: '411' },
  { x: 747.9, y: 298.4, zip3: '412' },
  { x: 736.9, y: 305.5, zip3: '413' },
  { x: 740, y: 300.1, zip3: '414' },
  { x: 755.2, y: 306.1, zip3: '415' },
  { x: 748.6, y: 306.1, zip3: '416' },
  { x: 741.3, y: 313, zip3: '417' },
  { x: 747.4, y: 312.5, zip3: '418' },
  { x: 651.8, y: 329.4, zip3: '420' },
  { x: 694.6, y: 326.3, zip3: '421' },
  { x: 678.4, y: 326.9, zip3: '422' },
  { x: 677, y: 315.4, zip3: '423' },
  { x: 666.4, y: 316.1, zip3: '424' },
  { x: 716.4, y: 317.9, zip3: '425' },
  { x: 717.6, y: 325.9, zip3: '426' },
  { x: 698.4, y: 315.7, zip3: '427' },
  { x: 737.7, y: 249.2, zip3: '430' },
  { x: 739.4, y: 259.5, zip3: '431' },
  { x: 737.2, y: 253.2, zip3: '432' },
  { x: 728.9, y: 242.7, zip3: '433' },
  { x: 727.9, y: 222.4, zip3: '434' },
  { x: 714.6, y: 224, zip3: '435' },
  { x: 723, y: 218.6, zip3: '436' },
  { x: 758.3, y: 253.1, zip3: '437' },
  { x: 754.3, y: 244.9, zip3: '438' },
  { x: 770.7, y: 243.1, zip3: '439' },
  { x: 757.5, y: 216.7, zip3: '440' },
  { x: 753.6, y: 218.8, zip3: '441' },
  { x: 756, y: 225.8, zip3: '442' },
  { x: 757, y: 226.7, zip3: '443' },
  { x: 769.2, y: 224.2, zip3: '444' },
  { x: 770.8, y: 224.2, zip3: '445' },
  { x: 759.1, y: 235.3, zip3: '446' },
  { x: 760.3, y: 231.7, zip3: '447' },
  { x: 737.6, y: 230.4, zip3: '448' },
  { x: 742.1, y: 235.9, zip3: '449' },
  { x: 714.5, y: 269.2, zip3: '450' },
  { x: 724.3, y: 274, zip3: '451' },
  { x: 715, y: 274, zip3: '452' },
  { x: 716.2, y: 255.9, zip3: '453' },
  { x: 718.5, y: 261.1, zip3: '454' },
  { x: 724.2, y: 256.6, zip3: '455' },
  { x: 742.9, y: 275.4, zip3: '456' },
  { x: 758.4, y: 264, zip3: '457' },
  { x: 715.3, y: 238.1, zip3: '458' },
  { x: 687.3, y: 255.8, zip3: '460' },
  { x: 686.6, y: 267, zip3: '461' },
  { x: 686.5, y: 263.4, zip3: '462' },
  { x: 666.6, y: 229.7, zip3: '463' },
  { x: 663.6, y: 227.3, zip3: '464' },
  { x: 684.3, y: 227.8, zip3: '465' },
  { x: 680.4, y: 223.2, zip3: '466' },
  { x: 698.4, y: 231.8, zip3: '467' },
  { x: 699.6, y: 234.2, zip3: '468' },
  { x: 685.6, y: 243.4, zip3: '469' },
  { x: 705.6, y: 275.1, zip3: '470' },
  { x: 692, y: 293.6, zip3: '471' },
  { x: 694.7, y: 279.1, zip3: '472' },
  { x: 700.9, y: 256.1, zip3: '473' },
  { x: 679.4, y: 281, zip3: '474' },
  { x: 675.5, y: 294.8, zip3: '475' },
  { x: 668.1, y: 301, zip3: '476' },
  { x: 666.8, y: 304.6, zip3: '477' },
  { x: 668.3, y: 272.8, zip3: '478' },
  { x: 670.2, y: 251.4, zip3: '479' },
  { x: 730.3, y: 195.3, zip3: '480' },
  { x: 722.5, y: 206.7, zip3: '481' },
  { x: 728.3, y: 202.4, zip3: '482' },
  { x: 724, y: 197.4, zip3: '483' },
  { x: 722.8, y: 184.2, zip3: '484' },
  { x: 717.2, y: 190.1, zip3: '485' },
  { x: 705.7, y: 173, zip3: '486' },
  { x: 716.7, y: 169.8, zip3: '487' },
  { x: 701.7, y: 191.6, zip3: '488' },
  { x: 704.5, y: 197.8, zip3: '489' },
  { x: 690, y: 210.8, zip3: '490' },
  { x: 677.2, y: 219, zip3: '491' },
  { x: 710, y: 212, zip3: '492' },
  { x: 688.1, y: 188.2, zip3: '493' },
  { x: 678.8, y: 188.8, zip3: '494' },
  { x: 687, y: 195.1, zip3: '495' },
  { x: 683.6, y: 161.1, zip3: '496' },
  { x: 697.8, y: 136.9, zip3: '497' },
  { x: 656.9, y: 130.3, zip3: '498' },
  { x: 631.5, y: 118, zip3: '499' },
  { x: 561.3, y: 231.3, zip3: '500' },
  { x: 566.3, y: 232.3, zip3: '501' },
  { x: 564.3, y: 231.1, zip3: '502' },
  { x: 563.2, y: 232.5, zip3: '503' },
  { x: 566.7, y: 198.4, zip3: '504' },
  { x: 550.1, y: 207.7, zip3: '505' },
  { x: 581.4, y: 209.6, zip3: '506' },
  { x: 583.9, y: 212.9, zip3: '507' },
  { x: 548.8, y: 246.5, zip3: '508' },
  { x: 527.3, y: 211.3, zip3: '510' },
  { x: 519.5, y: 213.2, zip3: '511' },
  { x: 525.1, y: 196.9, zip3: '512' },
  { x: 539.2, y: 197.1, zip3: '513' },
  { x: 540.7, y: 222, zip3: '514' },
  { x: 532.7, y: 235.8, zip3: '515' },
  { x: 535.8, y: 251.7, zip3: '516' },
  { x: 604.6, y: 211.5, zip3: '520' },
  { x: 592.1, y: 197.9, zip3: '521' },
  { x: 592.9, y: 225, zip3: '522' },
  { x: 593.4, y: 224.8, zip3: '523' },
  { x: 594.2, y: 223, zip3: '524' },
  { x: 582.9, y: 245.8, zip3: '525' },
  { x: 599.2, y: 246.9, zip3: '526' },
  { x: 608.5, y: 229.6, zip3: '527' },
  { x: 611.8, y: 231.6, zip3: '528' },
  { x: 646.2, y: 187.9, zip3: '530' },
  { x: 647.2, y: 202.8, zip3: '531' },
  { x: 650.9, y: 196.2, zip3: '532' },
  { x: 653.6, y: 202.8, zip3: '534' },
  { x: 625.5, y: 200.4, zip3: '535' },
  { x: 629.8, y: 197.5, zip3: '537' },
  { x: 607.7, y: 203.6, zip3: '538' },
  { x: 626.4, y: 185.9, zip3: '539' },
  { x: 578.9, y: 157.1, zip3: '540' },
  { x: 643.4, y: 157.3, zip3: '541' },
  { x: 654.4, y: 162.8, zip3: '542' },
  { x: 647.4, y: 165, zip3: '543' },
  { x: 619.9, y: 159.2, zip3: '544' },
  { x: 616.9, y: 137, zip3: '545' },
  { x: 603.9, y: 181.9, zip3: '546' },
  { x: 592.8, y: 161.4, zip3: '547' },
  { x: 590.7, y: 135.9, zip3: '548' },
  { x: 635.3, y: 172.8, zip3: '549' },
  { x: 570.8, y: 158.1, zip3: '550' },
  { x: 569.7, y: 160, zip3: '551' },
  { x: 557.7, y: 159.7, zip3: '553' },
  { x: 566.5, y: 159.3, zip3: '554' },
  { x: 598.1, y: 103.2, zip3: '556' },
  { x: 573, y: 112.3, zip3: '557' },
  { x: 582.7, y: 119.5, zip3: '558' },
  { x: 582.6, y: 182.2, zip3: '559' },
  { x: 557.2, y: 181, zip3: '560' },
  { x: 530.8, y: 183.2, zip3: '561' },
  { x: 530.8, y: 159, zip3: '562' },
  { x: 545.8, y: 142.8, zip3: '563' },
  { x: 547.7, y: 125.6, zip3: '564' },
  { x: 524.3, y: 120, zip3: '565' },
  { x: 548.3, y: 99.1, zip3: '566' },
  { x: 521.4, y: 86.4, zip3: '567' },
  { x: 509.9, y: 192.2, zip3: '570' },
  { x: 514.3, y: 191, zip3: '571' },
  { x: 508.7, y: 158.7, zip3: '572' },
  { x: 488.5, y: 184.9, zip3: '573' },
  { x: 484.1, y: 151.4, zip3: '574' },
  { x: 457.2, y: 184.6, zip3: '575' },
  { x: 444.6, y: 146.2, zip3: '576' },
  { x: 417, y: 174.9, zip3: '577' },
  { x: 506.3, y: 123.3, zip3: '580' },
  { x: 513.5, y: 119.5, zip3: '581' },
  { x: 502.1, y: 90.8, zip3: '582' },
  { x: 479.8, y: 86.8, zip3: '583' },
  { x: 481.4, y: 117.1, zip3: '584' },
  { x: 453.2, y: 119.4, zip3: '585' },
  { x: 423.3, y: 117.4, zip3: '586' },
  { x: 445.5, y: 85.6, zip3: '587' },
  { x: 417.6, y: 85.5, zip3: '588' },
  { x: 335.7, y: 130.1, zip3: '590' },
  { x: 338.3, y: 130.6, zip3: '591' },
  { x: 392, y: 81.8, zip3: '592' },
  { x: 385.2, y: 122.7, zip3: '593' },
  { x: 305.4, y: 83.5, zip3: '594' },
  { x: 333.2, y: 71.2, zip3: '595' },
  { x: 291.4, y: 106.4, zip3: '596' },
  { x: 283.3, y: 124.5, zip3: '597' },
  { x: 258.3, y: 90.3, zip3: '598' },
  { x: 261.7, y: 63.4, zip3: '599' },
  { x: 651.7, y: 213.9, zip3: '600' },
  { x: 648.6, y: 219.8, zip3: '601' },
  { x: 656.9, y: 217.5, zip3: '602' },
  { x: 655.6, y: 221.1, zip3: '603' },
  { x: 654.4, y: 229.2, zip3: '604' },
  { x: 647.9, y: 225.2, zip3: '605' },
  { x: 657.7, y: 221.3, zip3: '606' },
  { x: 655.6, y: 219.1, zip3: '607' },
  { x: 657.4, y: 224.5, zip3: '608' },
  { x: 655.2, y: 244.2, zip3: '609' },
  { x: 627.9, y: 216.3, zip3: '610' },
  { x: 635.3, y: 214, zip3: '611' },
  { x: 616, y: 232.4, zip3: '612' },
  { x: 634.2, y: 234.6, zip3: '613' },
  { x: 615.6, y: 246.7, zip3: '614' },
  { x: 627.3, y: 249.1, zip3: '615' },
  { x: 628.7, y: 248.9, zip3: '616' },
  { x: 640.1, y: 252.4, zip3: '617' },
  { x: 653.9, y: 260, zip3: '618' },
  { x: 652.9, y: 269.2, zip3: '619' },
  { x: 624.7, y: 284.6, zip3: '620' },
  { x: 628.9, y: 298.1, zip3: '622' },
  { x: 606.4, y: 265, zip3: '623' },
  { x: 654.1, y: 283, zip3: '624' },
  { x: 636.5, y: 270.1, zip3: '625' },
  { x: 623.9, y: 268.1, zip3: '626' },
  { x: 629.4, y: 268.6, zip3: '627' },
  { x: 647.7, y: 299.3, zip3: '628' },
  { x: 643.8, y: 316, zip3: '629' },
  { x: 614.3, y: 299, zip3: '630' },
  { x: 620.3, y: 294.2, zip3: '631' },
  { x: 607.7, y: 287.4, zip3: '633' },
  { x: 594.6, y: 267.1, zip3: '634' },
  { x: 581.2, y: 262.2, zip3: '635' },
  { x: 615.7, y: 315.6, zip3: '636' },
  { x: 630.9, y: 322.6, zip3: '637' },
  { x: 631.8, y: 339.9, zip3: '638' },
  { x: 618.9, y: 333.2, zip3: '639' },
  { x: 555.5, y: 287.2, zip3: '640' },
  { x: 549.6, y: 286.8, zip3: '641' },
  { x: 547.1, y: 265, zip3: '644' },
  { x: 544.8, y: 272.6, zip3: '645' },
  { x: 565.5, y: 269.7, zip3: '646' },
  { x: 555.8, y: 308.4, zip3: '647' },
  { x: 553.8, y: 333, zip3: '648' },
  { x: 587.8, y: 299.9, zip3: '650' },
  { x: 588.8, y: 298, zip3: '651' },
  { x: 585.1, y: 283.3, zip3: '652' },
  { x: 571.5, y: 293.8, zip3: '653' },
  { x: 596.1, y: 316.7, zip3: '654' },
  { x: 594.2, y: 317, zip3: '655' },
  { x: 574.3, y: 330.5, zip3: '656' },
  { x: 576.4, y: 330.3, zip3: '657' },
  { x: 571.6, y: 327.9, zip3: '658' },
  { x: 540.3, y: 290.9, zip3: '660' },
  { x: 547.3, y: 286.7, zip3: '661' },
  { x: 547, y: 289.9, zip3: '662' },
  { x: 524.8, y: 280.6, zip3: '664' },
  { x: 524.2, y: 282.1, zip3: '665' },
  { x: 530.5, y: 288.3, zip3: '666' },
  { x: 541.2, y: 319.6, zip3: '667' },
  { x: 519.3, y: 303.1, zip3: '668' },
  { x: 497.7, y: 271.9, zip3: '669' },
  { x: 498.7, y: 320.3, zip3: '670' },
  { x: 497.1, y: 320.2, zip3: '671' },
  { x: 503.4, y: 317.4, zip3: '672' },
  { x: 529.8, y: 328.4, zip3: '673' },
  { x: 496.7, y: 290.2, zip3: '674' },
  { x: 477.8, y: 304.9, zip3: '675' },
  { x: 469.5, y: 281.1, zip3: '676' },
  { x: 442.2, y: 279.5, zip3: '677' },
  { x: 447.3, y: 313, zip3: '678' },
  { x: 433.1, y: 326.1, zip3: '679' },
  { x: 518.8, y: 235.6, zip3: '680' },
  { x: 525.2, y: 240.6, zip3: '681' },
  { x: 512.4, y: 257.5, zip3: '683' },
  { x: 516, y: 255.7, zip3: '684' },
  { x: 514.8, y: 249.7, zip3: '685' },
  { x: 501.3, y: 235, zip3: '686' },
  { x: 498.4, y: 215.2, zip3: '687' },
  { x: 478.8, y: 241.6, zip3: '688' },
  { x: 479.9, y: 259.4, zip3: '689' },
  { x: 446.5, y: 257.9, zip3: '690' },
  { x: 436.6, y: 236.6, zip3: '691' },
  { x: 453.5, y: 207.1, zip3: '692' },
  { x: 414.9, y: 216.3, zip3: '693' },
  { x: 633.8, y: 483.3, zip3: '700' },
  { x: 636, y: 480.9, zip3: '701' },
  { x: 623.5, y: 488.6, zip3: '703' },
  { x: 631.8, y: 468.1, zip3: '704' },
  { x: 596.4, y: 477.2, zip3: '705' },
  { x: 578.1, y: 474.2, zip3: '706' },
  { x: 614.3, y: 470.1, zip3: '707' },
  { x: 616, y: 471.9, zip3: '708' },
  { x: 571, y: 429.2, zip3: '710' },
  { x: 566.2, y: 430.3, zip3: '711' },
  { x: 597.3, y: 427, zip3: '712' },
  { x: 599.6, y: 454.1, zip3: '713' },
  { x: 583.3, y: 449.3, zip3: '714' },
  { x: 601.4, y: 403.4, zip3: '716' },
  { x: 582.8, y: 407.5, zip3: '717' },
  { x: 563.6, y: 404.2, zip3: '718' },
  { x: 568.4, y: 388.8, zip3: '719' },
  { x: 595.8, y: 375.7, zip3: '720' },
  { x: 594.1, y: 375.6, zip3: '721' },
  { x: 589.3, y: 380.4, zip3: '722' },
  { x: 620.4, y: 371.7, zip3: '723' },
  { x: 616, y: 350.4, zip3: '724' },
  { x: 598, y: 352.3, zip3: '725' },
  { x: 579.3, y: 350, zip3: '726' },
  { x: 557.4, y: 350.8, zip3: '727' },
  { x: 570.9, y: 369.3, zip3: '728' },
  { x: 557.2, y: 368.4, zip3: '729' },
  { x: 495.4, y: 368.5, zip3: '730' },
  { x: 499.4, y: 365.4, zip3: '731' },
  { x: 505.3, y: 392.6, zip3: '734' },
  { x: 477.2, y: 385.5, zip3: '735' },
  { x: 469.2, y: 363.7, zip3: '736' },
  { x: 489.3, y: 345.4, zip3: '737' },
  { x: 465.9, y: 343.3, zip3: '738' },
  { x: 431.8, y: 335.1, zip3: '739' },
  { x: 522.4, y: 348.7, zip3: '740' },
  { x: 526.8, y: 351.3, zip3: '741' },
  { x: 543.1, y: 342.7, zip3: '743' },
  { x: 535, y: 362, zip3: '744' },
  { x: 531, y: 383.6, zip3: '745' },
  { x: 506.1, y: 339, zip3: '746' },
  { x: 533, y: 397.1, zip3: '747' },
  { x: 513.9, y: 371.8, zip3: '748' },
  { x: 548.2, y: 371, zip3: '749' },
  { x: 511.7, y: 417.8, zip3: '750' },
  { x: 518, y: 428.9, zip3: '751' },
  { x: 511.4, y: 423.2, zip3: '752' },
  { x: 510.6, y: 423.1, zip3: '753' },
  { x: 529.1, y: 411.1, zip3: '754' },
  { x: 554.5, y: 413.1, zip3: '755' },
  { x: 550.5, y: 430.1, zip3: '756' },
  { x: 537.7, y: 435.4, zip3: '757' },
  { x: 530.6, y: 451.9, zip3: '758' },
  { x: 555.7, y: 455.7, zip3: '759' },
  { x: 501.3, y: 426.6, zip3: '760' },
  { x: 501.9, y: 424.1, zip3: '761' },
  { x: 502.7, y: 409.8, zip3: '762' },
  { x: 476.7, y: 401.5, zip3: '763' },
  { x: 480.5, y: 428.4, zip3: '764' },
  { x: 497.4, y: 460.1, zip3: '765' },
  { x: 507.1, y: 446, zip3: '766' },
  { x: 504.7, y: 450.2, zip3: '767' },
  { x: 465, y: 454.5, zip3: '768' },
  { x: 441.8, y: 451.9, zip3: '769' },
  { x: 536.6, y: 488.6, zip3: '770' },
  { x: 537.5, y: 488.8, zip3: '772' },
  { x: 538.5, y: 476.3, zip3: '773' },
  { x: 526.3, y: 495.5, zip3: '774' },
  { x: 543.6, y: 492, zip3: '775' },
  { x: 559.7, y: 481.2, zip3: '776' },
  { x: 559.8, y: 481.9, zip3: '777' },
  { x: 520, y: 469.2, zip3: '778' },
  { x: 508.7, y: 508.1, zip3: '779' },
  { x: 471.4, y: 505.3, zip3: '780' },
  { x: 488.3, y: 501.5, zip3: '781' },
  { x: 478.7, y: 494.5, zip3: '782' },
  { x: 490.5, y: 531.9, zip3: '783' },
  { x: 498.6, y: 531.9, zip3: '784' },
  { x: 485.6, y: 562.6, zip3: '785' },
  { x: 489.5, y: 477.9, zip3: '786' },
  { x: 493, y: 476.9, zip3: '787' },
  { x: 450.3, y: 497.3, zip3: '788' },
  { x: 510.6, y: 485.6, zip3: '789' },
  { x: 429, y: 365.2, zip3: '790' },
  { x: 424.2, y: 367.8, zip3: '791' },
  { x: 444, y: 389.4, zip3: '792' },
  { x: 415.5, y: 404.7, zip3: '793' },
  { x: 421.1, y: 403.7, zip3: '794' },
  { x: 450.6, y: 424.9, zip3: '795' },
  { x: 457.7, y: 430.3, zip3: '796' },
  { x: 407.1, y: 443.2, zip3: '797' },
  { x: 364.8, y: 458.9, zip3: '798' },
  { x: 340.7, y: 436.1, zip3: '799' },
  { x: 379.6, y: 264.9, zip3: '800' },
  { x: 381.8, y: 271.9, zip3: '801' },
  { x: 379.1, y: 266.1, zip3: '802' },
  { x: 375, y: 259.9, zip3: '803' },
  { x: 363.7, y: 262.6, zip3: '804' },
  { x: 377.5, y: 251.6, zip3: '805' },
  { x: 386.5, y: 253.9, zip3: '806' },
  { x: 412, y: 253.5, zip3: '807' },
  { x: 396.8, y: 282.2, zip3: '808' },
  { x: 381.3, y: 285.9, zip3: '809' },
  { x: 396.2, y: 307.8, zip3: '810' },
  { x: 354.1, y: 313.7, zip3: '811' },
  { x: 356.6, y: 290.9, zip3: '812' },
  { x: 316, y: 308.8, zip3: '813' },
  { x: 325.5, y: 289.5, zip3: '814' },
  { x: 317.9, y: 274, zip3: '815' },
  { x: 340.2, y: 263, zip3: '816' },
  { x: 379.7, y: 232.3, zip3: '820' },
  { x: 304.8, y: 152.3, zip3: '821' },
  { x: 390.7, y: 210.3, zip3: '822' },
  { x: 349.5, y: 221.7, zip3: '823' },
  { x: 336.9, y: 159.2, zip3: '824' },
  { x: 326.4, y: 186.2, zip3: '825' },
  { x: 359.9, y: 190.9, zip3: '826' },
  { x: 390.6, y: 167.2, zip3: '827' },
  { x: 360.9, y: 156.5, zip3: '828' },
  { x: 306.8, y: 213, zip3: '829' },
  { x: 299.3, y: 171.8, zip3: '830' },
  { x: 295.2, y: 194.7, zip3: '831' },
  { x: 271, y: 183.2, zip3: '832' },
  { x: 241, y: 178.9, zip3: '833' },
  { x: 278.7, y: 158.6, zip3: '834' },
  { x: 226, y: 102.7, zip3: '835' },
  { x: 215.6, y: 150.2, zip3: '836' },
  { x: 215.4, y: 156.1, zip3: '837' },
  { x: 229.1, y: 70.6, zip3: '838' },
  { x: 277.8, y: 233.5, zip3: '840' },
  { x: 270.8, y: 230.5, zip3: '841' },
  { x: 270.6, y: 208.9, zip3: '843' },
  { x: 270.7, y: 219.3, zip3: '844' },
  { x: 289.2, y: 276.8, zip3: '845' },
  { x: 266.6, y: 256.4, zip3: '846' },
  { x: 247.2, y: 290.5, zip3: '847' },
  { x: 241.3, y: 383.4, zip3: '850' },
  { x: 249.4, y: 396.1, zip3: '851' },
  { x: 245.9, y: 386.2, zip3: '852' },
  { x: 226.6, y: 382.3, zip3: '853' },
  { x: 272.6, y: 393.4, zip3: '855' },
  { x: 264.4, y: 423.8, zip3: '856' },
  { x: 256.6, y: 414.4, zip3: '857' },
  { x: 282.3, y: 375, zip3: '859' },
  { x: 265.2, y: 338.9, zip3: '860' },
  { x: 241.4, y: 358.3, zip3: '863' },
  { x: 213.1, y: 340.1, zip3: '864' },
  { x: 295.2, y: 336.9, zip3: '865' },
  { x: 338.7, y: 360.1, zip3: '870' },
  { x: 341.2, y: 362.9, zip3: '871' },
  { x: 308, y: 350.7, zip3: '873' },
  { x: 317.8, y: 326.1, zip3: '874' },
  { x: 356.3, y: 342.1, zip3: '875' },
  { x: 372.1, y: 346.1, zip3: '877' },
  { x: 318.5, y: 383.4, zip3: '878' },
  { x: 323.7, y: 407.8, zip3: '879' },
  { x: 317.7, y: 419.1, zip3: '880' },
  { x: 393, y: 387.3, zip3: '881' },
  { x: 383.2, y: 418.1, zip3: '882' },
  { x: 354.7, y: 405, zip3: '883' },
  { x: 391.8, y: 355, zip3: '884' },
  { x: 196.5, y: 307.9, zip3: '890' },
  { x: 197.8, y: 317.9, zip3: '891' },
  { x: 209.7, y: 251.1, zip3: '893' },
  { x: 152, y: 228.5, zip3: '894' },
  { x: 139.5, y: 228, zip3: '895' },
  { x: 137.8, y: 236.6, zip3: '897' },
  { x: 214.2, y: 211.5, zip3: '898' },
  { x: 135.6, y: 350.6, zip3: '900' },
  { x: 134.2, y: 352.4, zip3: '902' },
  { x: 134.4, y: 352.3, zip3: '903' },
  { x: 132.3, y: 350.3, zip3: '904' },
  { x: 134.2, y: 354.7, zip3: '905' },
  { x: 139.7, y: 354.3, zip3: '906' },
  { x: 136.4, y: 356.3, zip3: '907' },
  { x: 136.7, y: 356.4, zip3: '908' },
  { x: 139.4, y: 348.3, zip3: '910' },
  { x: 139.1, y: 349.1, zip3: '911' },
  { x: 137.1, y: 348.2, zip3: '912' },
  { x: 131.9, y: 344.7, zip3: '913' },
  { x: 133.6, y: 347.1, zip3: '914' },
  { x: 136, y: 347.5, zip3: '915' },
  { x: 134.9, y: 347.7, zip3: '916' },
  { x: 143.9, y: 351.8, zip3: '917' },
  { x: 138.7, y: 350.4, zip3: '918' },
  { x: 155.4, y: 385, zip3: '919' },
  { x: 152.4, y: 374.9, zip3: '920' },
  { x: 149.6, y: 381.9, zip3: '921' },
  { x: 174.9, y: 369.2, zip3: '922' },
  { x: 160.4, y: 346.2, zip3: '923' },
  { x: 153.2, y: 352.7, zip3: '924' },
  { x: 153.8, y: 361.3, zip3: '925' },
  { x: 142.5, y: 361.5, zip3: '926' },
  { x: 141.7, y: 358.8, zip3: '927' },
  { x: 142.9, y: 356.8, zip3: '928' },
  { x: 122.3, y: 342.9, zip3: '930' },
  { x: 112.6, y: 335.8, zip3: '931' },
  { x: 129.8, y: 309.3, zip3: '932' },
  { x: 130.2, y: 320, zip3: '933' },
  { x: 103.3, y: 316.5, zip3: '934' },
  { x: 146.7, y: 318, zip3: '935' },
  { x: 126.8, y: 285.9, zip3: '936' },
  { x: 124.7, y: 287, zip3: '937' },
  { x: 93.8, y: 285.5, zip3: '939' },
  { x: 88.2, y: 261.6, zip3: '940' },
  { x: 87.3, y: 254.6, zip3: '941' },
  { x: 89.8, y: 263.1, zip3: '943' },
  { x: 87.9, y: 259.7, zip3: '944' },
  { x: 94.4, y: 252.6, zip3: '945' },
  { x: 90.8, y: 254.9, zip3: '946' },
  { x: 90.5, y: 253, zip3: '947' },
  { x: 89.9, y: 251.4, zip3: '948' },
  { x: 85.1, y: 246.9, zip3: '949' },
  { x: 92.6, y: 271.4, zip3: '950' },
  { x: 94, y: 266.7, zip3: '951' },
  { x: 113.4, y: 253.9, zip3: '952' },
  { x: 115, y: 265.1, zip3: '953' },
  { x: 83.8, y: 228.1, zip3: '954' },
  { x: 82, y: 187.2, zip3: '955' },
  { x: 110.9, y: 241.5, zip3: '956' },
  { x: 118.9, y: 237.8, zip3: '957' },
  { x: 108, y: 242.2, zip3: '958' },
  { x: 112.2, y: 222.8, zip3: '959' },
  { x: 108.3, y: 189.9, zip3: '960' },
  { x: 134.5, y: 216.6, zip3: '961' },
  { x: 313.3, y: 539.2, zip3: '967' },
  { x: 307.6, y: 533, zip3: '968' },
  { x: 135.8, y: 96.1, zip3: '970' },
  { x: 118.1, y: 88.7, zip3: '971' },
  { x: 130, y: 92.5, zip3: '972' },
  { x: 117.5, y: 106.2, zip3: '973' },
  { x: 107.1, y: 129.6, zip3: '974' },
  { x: 104.9, y: 155.5, zip3: '975' },
  { x: 134.1, y: 161.8, zip3: '976' },
  { x: 151.7, y: 136.3, zip3: '977' },
  { x: 187.4, y: 114.9, zip3: '978' },
  { x: 196, y: 144.7, zip3: '979' },
  { x: 149.6, y: 52.8, zip3: '980' },
  { x: 146.8, y: 51.2, zip3: '981' },
  { x: 152, y: 35.4, zip3: '982' },
  { x: 141, y: 52.8, zip3: '983' },
  { x: 142.6, y: 58.6, zip3: '984' },
  { x: 130.1, y: 61, zip3: '985' },
  { x: 135.1, y: 84.5, zip3: '986' },
  { x: 182.5, y: 54.5, zip3: '988' },
  { x: 166.8, y: 76.5, zip3: '989' },
  { x: 215.9, y: 68.3, zip3: '990' },
  { x: 209, y: 62.4, zip3: '991' },
  { x: 217.2, y: 67.4, zip3: '992' },
  { x: 188, y: 89.5, zip3: '993' },
  { x: 212.5, y: 98.4, zip3: '994' },
  { x: 139.3, y: 529.7, zip3: '995' },
  { x: 133.9, y: 530.1, zip3: '996' },
  { x: 146.6, y: 487.2, zip3: '997' },
  { x: 220.7, y: 536.8, zip3: '998' },
  { x: 236.7, y: 548.9, zip3: '999' },
];

const BY_ZIP3: Record<string, Zip3Centroid> = {};
for (const c of ZIP3_CENTROIDS) {
  BY_ZIP3[c.zip3] = c;
}

/** Look up the map coordinate for a ZIP code by its first 3 digits. */
export function zip3Centroid(zip?: string | null): Zip3Centroid | undefined {
  if (!zip) {
    return undefined;
  }
  const digits = zip.replace(/\D/g, '');
  if (digits.length < 3) {
    return undefined;
  }
  return BY_ZIP3[digits.slice(0, 3)];
}
